export const ENV = {
  APP_ID: import.meta.env.VITE_APP_ID || 'driver-app',
  APP_VERSION: import.meta.env.VITE_APP_VERSION || 'preview',
  CLIENT_ID: import.meta.env.VITE_CLIENT_ID,
  STAGE: import.meta.env.VITE_STAGE,
};
